<template>
    <div class="hrm_counters_card themeCards px-2 py-2
           flex items-center gap-3
           sm:flex-row sm:items-center
           justify-between" :class="extraClass">

        <!-- ICON -->
        <div class="flex-none flex items-center justify-center gap-1
             w-7 h-7 sm:w-8 sm:h-8 hrmCounterIconCard" :class="isIncrease ? 'text-green-500' : 'text-red-500'">
            <slot name="counterIcon">
                <span class="hrm_counter_icon text-sm font-bold text-gray-200">
                    <Icon :icon="counterIcon" width="18px" height="18px" />
                </span>
            </slot>
        </div>

        <!-- TEXT AREA -->
        <div class="flex-1">

            <!-- MOBILE LAYOUT -->
            <div class="flex items-center justify-between sm:hidden">
                <h4 class="hrm_counter_title text-xs font-bold truncate">
                    {{ counterTitle }}
                </h4>

                <h2 class="hrm_counter_value text-lg font-bold text-white">
                    {{ counter ?? 0 }}
                </h2>
            </div>

            <!-- DESKTOP LAYOUT (same as your original) -->
            <div class="hidden sm:block">
                <div class="flex items-center justify-between">
                    <slot name="counterTitle">
                        <h2 class="hrm_counter_value text-xl  dark:text-gray-200 font-bold">
                            {{ counter ?? 0 }}
                        </h2>
                    </slot>
                </div>

                <div>
                    <h4 class="hrm_counter_title text-xs font-bold">
                        {{ counterTitle }}
                    </h4>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import { Icon } from '@iconify/vue';
export default {
    components: {
        Icon
    },
    props: ['counterTitle', 'counter', 'extraClass', 'textColor', 'isIncrease', "counterIcon"],
    data() {
        return {

        };
    },
    methods: {

    },
};
</script>
<style scoped>
.hrm_active_counter {
    background-color: var(--hrm_Theme_Layout_Primary_Color) !important;
    color: var(--hrm_Theme_Layout_Text_Color) !important;
}

.hrm_counters_card {
    transition: .4s !important;
    border-radius: 6px !important;
}

.hrm_counters_card:hover,
.hrm_active_counter .hrmCounterIconCard,
.hrm_counters_card:hover .hrmCounterIconCard {
    background-color: var(--hrm_Theme_Layout_Primary_Color) !important;
}

.hrm_active_counter .hrmCounterIconCard,
.hrm_counters_card:hover .hrmCounterIconCard {
    filter: brightness(1.2);
}

.hrm_active_counter {
    font-size: 12px;
}

.hrm_counters_card:hover .hrm_counter_title,
.hrm_counters_card:hover .hrm_counter_value,
.hrm_counters_card:hover .hrm_counter_icon,
.hrm_active_counter .hrm_counter_title,
.hrm_active_counter .hrm_counter_icon,
.hrm_active_counter .hrm_counter_value {
    color: var(--hrm_Theme_Layout_Text_Color) !important;
}

.dark .hrmCounterIconCard {
    background-color: #26292c;
}

.hrmCounterIconCard {
    border-radius: 100px;
}

.hrm_counter_title {
    color: var(--hrm_Theme_Layout_Secondary_Color) !important;
}
</style>